import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { retrieve } from "../../helpers/StorageHelper";

export default function SignUp3() {
  const navigate = useNavigate();

  const [imageUrl, setImageUrl] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showImageError, setShowImageError] = useState(false);

  useEffect(() => {
    const savedImage = retrieve("image");
    if (savedImage) {
      setImageUrl(savedImage);
    }
  }, []);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      // Check file type
      const validTypes = [
        "image/jpeg",
        "image/png",
        "image/jpg",
        "image/svg+xml",
      ];
      const isValidType = validTypes.includes(file.type);

      if (!isValidType) {
        setShowImageError(true);
        setError("The image must be a file of type: jpeg, png, jpg, gif, svg");
        return;
      }
      setShowImageError(false);
      setError("");

      const reader = new FileReader();
      reader.onload = (e) => {
        setImageUrl(e.target.result);
      };
      reader.readAsDataURL(file);
      setSelectedFile(file);
    }
  };

  const handleNext = () => {
    // localStorage.setItem("image", imageUrl || "");
    setIsLoading(true);
    navigate("/signup/details", { state: { image: imageUrl } });
  };

  return (
    <div className="onboarding-container">
      <div className="onboard-content">
        <div className="d-flex flex-column justify-content-center align-items-center">
          <div className="progress-container">
            <div
              style={{
                background: "url(/icons/progress-tick.svg)",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
              className="step active"
              data-step="1"
            ></div>
            <div className="progress-line active" data-line="1"></div>
            <div className="step active stepactive" data-step="2"></div>
            <div className="progress-line" data-line="2"></div>
            <div className="step" data-step="3"></div>
            <div className="progress-line" data-line="3"></div>
            <div className="step" data-step="4"></div>
          </div>

          <h1
            style={{
              marginBottom: "40px",
              textAlign: "center",
              color: "rgba(230, 236, 241, 1)",
              fontFamily: "Poppins",
              fontSize: "20px",
              lineHeight: "30px",
              fontWeight: 600,
            }}
          >
            Add your profile photo
            <span style={{ marginLeft: "12px" }}>2 / 4</span>
          </h1>
          <div className="d-flex flex-column align-items-center w-100 padding-card">
            <div
              style={{
                border: "3px dotted rgba(27, 44, 58, 1)",
                borderRadius: "24px",
                maxWidth: "343px",
                width: "100%",
              }}
              className="d-flex flex-column justify-content-between align-content-center align-items-center"
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  maxWidth: "91px",
                  width: "100%",
                  height: "91px",
                  backgroundColor: "rgba(27, 44, 58, 1)",
                  borderRadius: "50%",
                  marginTop: "24px",
                  marginBottom: "16px",
                  cursor: "pointer",
                }}
              >
                <input
                  type="file"
                  id="file-upload"
                  style={{ display: "none" }}
                  accept="image/*"
                  onChange={handleFileUpload}
                />
                <img
                  src={imageUrl || "/icons/camera.svg"}
                  alt="camera icon"
                  onClick={() => document.getElementById("file-upload").click()}
                  id="image-preview"
                  style={
                    imageUrl
                      ? {
                          objectFit: "cover",
                          width: "91px",
                          height: "91px",
                          borderRadius: "50%",
                        }
                      : {}
                  }
                />
              </div>
              <div
                style={{
                  textAlign: "center",
                  gap: "4px",
                  marginBottom: "24px",
                }}
              >
                <span
                  style={{
                    fontFamily: "Poppins",
                    marginTop: "12px",
                    color: "rgba(255, 255, 255, 1)",
                    fontSize: "16px",
                    lineHeight: "24px",
                  }}
                >
                  Tap above to upload photo
                </span>
              </div>
            </div>
            {showImageError && (
              <div
                className="signup-error"
                style={{
                  color: "#C03A31",
                  fontSize: "16px",
                  marginTop: "8px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                The image must be a file of type: jpeg, png, jpg, svg
              </div>
            )}

            <div
              className="d-flex flex-column flex-sm-row gap-3 gap-sm-4 terms-buttons justify-content-between align-items-center w-100"
              style={{
                maxWidth: "345px",
                marginTop: "30px",
                marginBottom: "40px",
              }}
            >
              <button
                onClick={() => navigate("/sign-up")}
                className="btn-1 btn-1-basic"
                style={{ maxWidth: "160px", width: "100%" }}
              >
                Back
              </button>

              <button
                onClick={handleNext}
                id="nextButton"
                className="btn-1 btn-1-primary"
                style={{
                  maxWidth: "160px",
                  width: "100%",
                  backgroundColor: isLoading
                    ? "rgba(153, 209, 255, 1)"
                    : "rgba(0, 140, 255, 1)",
                  cursor: isLoading ? "not-allowed" : "pointer",
                }}
                disabled={isLoading}
              >
                {isLoading ? "Loading..." : "Next"}
              </button>

              {/* <button
                onClick={handleNext}
                id="nextButton"
                className="btn-1 btn-1-primary"
                style={{
                  maxWidth: "160px",
                  width: "100%",
                  backgroundColor: selectedFile
                    ? "rgba(0, 140, 255, 1)"
                    : "rgba(153, 209, 255, 1)",
                  cursor: selectedFile ? "pointer" : "not-allowed",
                }}
                disabled={!selectedFile}
              ></button> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
